import { useKeycloak } from '@react-keycloak/web';
import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import CLocalizedTextStringStatic from '../../components/CLocalizedTextStringStatic';
import { PageRoutes } from '../../enums/enums';
import { useAppDispatch } from '../../hooks/hooks';
import { addBreadcrumbTextReplacement, purgeBreadcrumbTextReplacementDictForOutlets } from '../../store/appSlice';

export default function PSignUpOutlet() {
  const dispatch = useAppDispatch();
  const signUpTitle = CLocalizedTextStringStatic('signUp.title');
  const navigate = useNavigate();
  const { keycloak } = useKeycloak();

  useEffect(() => {
    if (keycloak.authenticated) {
      navigate(`../${PageRoutes.NEWS_OUTLET}`);
    }
  }, [keycloak]);

  useEffect(() => {
    dispatch(addBreadcrumbTextReplacement([PageRoutes.SIGN_UP_OUTLET, signUpTitle]));

    return () => {
      dispatch(purgeBreadcrumbTextReplacementDictForOutlets());
    };
  }, [dispatch, signUpTitle]);
  return <Outlet />;
}
